import { ILayout } from 'src/interfaces';

export interface LayoutListCardProps {
  layout: ILayout;
  onClicked: (layout: ILayout) => void;
}

export enum IStatusColor {
  ready = 'success',
  draft = 'primary',
}
